<script>
export default {
    name: "PrintProfitLoss",

    data() {

        return {
            pLcs: [],
        };
    },

    mounted() {
        this.$root.loading = true;
        Promise.all([ this.fetchProfitAndLoss(), ]).then(() => {
            this.$root.loading = false;
            setTimeout(() => {
                window.print();
            }, 200);
        }).catch(() => { this.$root.loading = false; });
    },

    methods: {
        fetchProfitAndLoss() {
            let url = `Accounting/GetProfitnLoss`;
                url += `?FromDate=${this.$route.query.from}`;
                url += `&ToDate=${this.$route.query.to}`;
                url += `&UserName=${this.$root.username}`;
            return this.$http.get(url).then(({ data }) => {
                this.pLcs = data;
            }).catch(() => {});
        },
    },
}
</script>
<template>
<div class="w-full flex flex-wrap">
        <div class="w-full p-2">
            <h2 class="text-lg font-bold">Profit And Loss Report</h2>
        </div>
        <div class="w-full">
            <table class="table border" id="table-profit-n-loss">
                    <thead class="text-sm border-b-2 bg-gray-300">
                        <tr>
                            <th class="p-tiny whitespace-nowrap">
                                Ordinary Income/Expenses</th>
                            <th class="p-tiny whitespace-nowrap"></th>
                        </tr>
                    </thead>
                    <thead class="text-sm border-b-2 bg-gray-200">
                        <tr>
                            <th class="p-tiny whitespace-nowrap">
                                <span class="ml-3">Income</span></th>
                            <th class="p-tiny whitespace-nowrap"></th>
                        </tr>
                    </thead>
                    <tbody class=" bg-gray-100">
                        <tr class="border-b-2" 
                            v-for="(pLc, idx) in pLcs.filter(pl => pl.sortname == `Income`)" 
                            :key="`__${idx}`"
                            :class="idx%2 > 0 ? `bg-gray-100` : ``"
                            >
                            <td class="p-tiny">
                                <span class="ml-6">{{ pLc.particulars }}</span>
                            </td>
                            <td class="p-tiny">
                                {{ $formatCurrency(pLc.value) }}
                            </td>
                        </tr>
                    </tbody>
                    <tbody class=" bg-gray-100">
                        <tr class="border-b-2" 
                            v-for="(pLc, idx) in pLcs.filter(pl => pl.particulars == `Other Income`)" 
                            :key="`__${idx}`"
                            :class="idx%2 > 0 ? `bg-gray-100` : ``"
                            >
                            <td class="p-tiny">
                                <span class="ml-6">{{ pLc.particulars }}</span>
                            </td>
                            <td class="p-tiny">
                                {{ $formatCurrency(pLc.value) }}
                            </td>
                        </tr>
                    </tbody>
                    <thead class="text-sm border-b-2 bg-gray-300">
                        <tr>
                            <th class="p-tiny whitespace-nowrap">
                                <span class="ml-3">Other Income</span></th>
                            <th class="p-tiny whitespace-nowrap"></th>
                        </tr>
                    </thead>
                    <tbody class="bg-gray-100">
                        <tr class="border-b-2" 
                            v-for="(pLc, idx) in pLcs.filter(pl => pl.particulars == `Total Other Income`)" 
                            :key="`__${idx}`"
                            :class="idx%2 > 0 ? `bg-gray-100` : ``"
                            >
                            <td class="p-tiny">
                                <span class="ml-6">{{ pLc.particulars }}</span>
                            </td>
                            <td class="p-tiny">
                                {{ $formatCurrency(pLc.value) }}
                            </td>
                        </tr>
                    </tbody>
                    <thead class="text-sm border-b-2 bg-gray-300">
                        <tr>
                            <th class="p-tiny whitespace-nowrap">
                                <span class="ml-3">Total Income</span></th>
                            <th class="p-tiny whitespace-nowrap">
                                {{ 
                                    pLcs.filter(pl => pl.particulars == `Total Income`).length ?
                                      $formatCurrency(pLcs.filter(pl => pl.particulars == `Total Income`)[0].value)
                                     : 0
                                }}</th>
                        </tr>
                    </thead>
                    <thead class="text-sm border-b-2 bg-gray-300">
                        <tr class="border-b-2">
                            <th class="p-tiny whitespace-nowrap">
                                Expenses</th>
                            <th class="p-tiny whitespace-nowrap">
                                </th>
                        </tr>
                        <tr v-for="(pLc, idx) in pLcs.filter(pl => 
                                pl.particulars == `Administrative Expenses`)"
                            :key="`${idx}__`"
                            class="border-b-2">
                            <th class="p-tiny whitespace-nowrap">
                                <span class="ml-4">{{ pLc.particulars }}</span></th>
                            <th class="p-tiny whitespace-nowrap">
                                {{ $formatCurrency(pLc.value) }}</th>
                        </tr>
                        <tr v-for="(pLc, idx) in pLcs.filter(pl => 
                                pl.particulars == `Total Administrative Expenses`)"
                            :key="idx"
                            class="border-b-2">
                            <th class="p-tiny whitespace-nowrap">
                                <span class="ml-2">{{ pLc.particulars }}</span></th>
                            <th class="p-tiny whitespace-nowrap">
                                {{ $formatCurrency(pLc.value) }}</th>
                        </tr>
                    </thead>
                    <tbody class="bg-gray-100">
                        <tr class="border-b-2" 
                            v-for="(pLc, idx) in pLcs.filter(pl => pl.sortname == `Expenses`)" 
                            :key="`${idx}_`"
                            :class="idx%2 > 0 ? `bg-gray-100` : ``"
                            >
                            <td class="py-tiny capitalize">
                                <span class="ml-6">{{ pLc.particulars }}</span>
                            </td>
                            <td class="py-tiny">
                                {{ pLc.value ? $formatCurrency(pLc.value) : 0 }}
                            </td>
                        </tr>
                    </tbody>
                    <thead class="text-sm border-b-2 bg-gray-200">
                        <tr>
                            <th class="py-tiny whitespace-nowrap">
                                <span class="ml-3">Total Expenses</span></th>
                            <th class="py-tiny whitespace-nowrap">
                                {{ 
                                    pLcs.filter(pl => pl.particulars == `Total Expenses`).length ?
                                      $formatCurrency(pLcs.filter(pl => pl.particulars == `Total Expenses`)[0].value)
                                     : 0
                                }}</th>
                        </tr>
                    </thead>
                    <thead class="text-sm border-b-2 bg-gray-300">
                        <tr>
                            <th class="py-tiny whitespace-nowrap">
                                <span>Net Ordinary Income</span></th>
                            <th class="py-tiny whitespace-nowrap">
                                {{ 
                                    pLcs.filter(pl => pl.particulars == `Net Ordinary Income`).length ?
                                      $formatCurrency(pLcs.filter(pl => pl.particulars == `Net Ordinary Income`)[0].value)
                                     : 0
                                     }}</th>
                        </tr>
                    </thead>
                </table>
        </div>
    </div>
</template>